/** Render server-provided diagnostics as plain text, never HTML. */
export function executionError(value: unknown): string {
  if (typeof value === "string") return value.trim();
  if (!value || typeof value !== "object") return "";
  const error = value as Record<string, unknown>;
  const code = typeof error.code === "string" ? error.code : "";
  const message = typeof error.message === "string" ? error.message : "";
  const details =
    typeof error.details === "string"
      ? error.details
      : error.details
        ? JSON.stringify(error.details, null, 2)
        : "";
  return [code ? `[${code}] ${message}`.trim() : message, details]
    .filter(Boolean)
    .join("\n");
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: unknown,
    public requestId?: string,
  ) {
    super(executionError({ code, message, details }));
    this.name = "ApiError";
  }
}
